import React from 'react';
import { DialogComponent } from '../../DialogComponent/DialogComponent';
import { Button, makeStyles } from '@material-ui/core';
import { AssignmentInd, Person } from '@material-ui/icons';
import { LeadTypeIdEnum } from '../../../Enums';

const styles = makeStyles({
  button: {
    flex: '1 1 100%',
    padding: '24px',
    '& .subtitle': {
      fontSize: '12px',
      fontWeight: 400,
      textTransform: 'capitalize',
      lineHeight: '30px',
    },
  },
});
const SelectLeadTypeDialog = ({ open, setOpen, onLeadTypeSelect }) => {
  const classes = styles();
  if (!open) {
    return null;
  }
  return (
    <DialogComponent
      isOpen={open}
      titleText={'Select Lead Type'}
      onCloseClicked={() => setOpen(false)}
      maxWidth='sm'
      dialogContent={
        <div className='flex gap-20 fa-center fj-evenly py-2'>
          <Button
            className={classes.button}
            variant='outlined'
            size='large'
            onClick={() => onLeadTypeSelect(LeadTypeIdEnum.Seeker.leadTypeId)}
          >
            <div className='d-flex-column-center'>
              <Person fontSize='large' color='primary' />
              <strong className='capitalize'>Seeker Lead</strong>
              <span className='subtitle'>Looking to buy or rent</span>
            </div>
          </Button>
          <Button
            className={classes.button}
            variant='outlined'
            size='large'
            onClick={() => onLeadTypeSelect(LeadTypeIdEnum.Owner.leadTypeId)}
          >
            <div className='d-flex-column-center'>
              <AssignmentInd fontSize='large' color='primary' />
              <strong className='capitalize'>Owner Lead</strong>
              <span className='subtitle'>Looking to sell or rent</span>
            </div>
          </Button>
        </div>
      }
    />
  );
};
export default SelectLeadTypeDialog;
